<template>
  <v-dialog v-model="showDialog" persistent max-width="1000px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ title }}</span>
      </v-card-title>
      <v-card-text v-if="additionalInfo">
        <v-alert value="true" type="info" class="mb-3">
          {{ additionalInfo }}
        </v-alert>
      </v-card-text>
      <v-card-text>
        <v-layout row>
          <v-flex>
            <v-form v-model="valid">
              <v-text-field
                browser-autocomplete="off"
                data-vv-name="name"
                data-vv-as="label"
                :label="label"
                :error-messages="errorMessages"
                :rules="rules"
                single-line
                v-model="editedValue"
                data-vv-scope="scope1"
                v-if="fieldType === 'SHORT_TEXT'"
                aria-label="label for text"
              >
              </v-text-field>
              <v-autocomplete
                :label="label"
                :error-messages="errorMessages"
                :rules="rules"
                :items="selectItems"
                item-text="name"
                item-value="id"
                v-model="editedValue"
                v-if="fieldType === 'SELECT'"
                aria-label="label for text"
                clearable
              >
              </v-autocomplete>
              <v-select
                :label="label"
                :error-messages="errorMessages"
                :rules="rules"
                :items="selectItems"
                :multiple="true"
                chips
                item-text="name"
                item-value="id"
                v-model="editedValue"
                v-if="fieldType === 'SELECT_MANY'"
                aria-label="label for text"
              >
              </v-select>
              <v-textarea
                browser-autocomplete="off"
                data-vv-name="name"
                data-vv-as="label"
                :label="label"
                :error-messages="errorMessages"
                :rules="rules"
                v-model="editedValue"
                data-vv-scope="scope1"
                v-if="fieldType === 'LONG_TEXT'"
                aria-label="label for text"
              >
              </v-textarea>
              <egranty-number-input-field
                aria-label="label for number"
                v-model="editedValue"
                :label="label"
                for="contest-financial-settings-view-min-funding"
                id="contest-financial-settings-view-min-funding"
                :suffix="suffix"
                :validation-rules="rules"
                v-if="fieldType === 'NUMBER'"
                :placeholder="placeholder"
              ></egranty-number-input-field>
            </v-form>
          </v-flex>
          <v-flex xs5 v-if="!long" />
          <v-flex xs1 />
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="valid" color="primary" flat @click="save" :loading="loading" :disabled="loading">
          {{ saveButtonLabel }}
        </v-btn>
        <v-btn color="blue" @click="cancel"> Anuluj </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import EgrantyNumberInputField from "./EgrantyNumberInputField";

export default {
  name: "EgrantyInputFieldPopup",
  components: { EgrantyNumberInputField },

  data() {
    return {
      editedValue: this.defaultValue,
      errorMessages: "",
      valid: false,
      showDialog: this.isOpen,
    };
  },

  computed: {
    rules() {
      if (this.required) {
        return [requiredRule, ...this.validationRules];
      } else {
        return [...this.validationRules];
      }
    },
  },

  methods: {
    save() {
      this.$emit("save", this.editedValue);
      this.editedValue = "";
      this.errorMessages = "";
    },

    cancel() {
      this.$emit("cancel");
      this.updateVisibility(false);
      this.editedValue = "";
      this.errorMessages = "";
    },

    updateVisibility(visible) {
      this.showDialog = visible;
      this.$emit("update:isOpen", visible);
    },
  },

  watch: {
    isOpen: {
      immediate: true,
      handler(val) {
        if (val) this.editedValue = this.defaultValue;
        this.showDialog = val;
      },
    }
  },

  props: {
    title: { type: String, default: "Tytuł" },
    label: { type: String, default: "nazwa pola" },
    isOpen: { type: Boolean, default: false },
    fieldType: { type: String, default: "SHORT_TEXT" },
    selectItems: { type: Array, default: () => [] },
    defaultValue: { default: () => "" },
    validationRules: { type: Array, default: () => [] },
    required: { type: Boolean, default: true },
    long: { type: Boolean, default: false },
    saveButtonLabel: { type: String, default: "zapisz" },
    placeholder: { type: String },
    suffix: { type: String },
    additionalInfo: { type: String },
    loading: {type: Boolean, default: false}
  },
};

function requiredRule(value) {
  return !value ? "To pole jest wymagane." : true;
}
</script>

<style scoped>
</style>
